import { initializeApp } from "firebase/app";
import { browserSessionPersistence, initializeAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { appEnvironment, installEnvironmentNetworkGuard } from "./config/appEnvironment";

const firebaseConfig = appEnvironment.firebase;
installEnvironmentNetworkGuard();

const app = initializeApp(firebaseConfig);
// Initialize with session storage only so old long-lived browser sessions are
// not restored. Refreshes retain the session; closing the tab ends it.
const auth = initializeAuth(app, { persistence: browserSessionPersistence });
const db = getFirestore(app, appEnvironment.databaseId);
const storage = getStorage(app);
const legacyStorage = storage;
const functions = getFunctions(app);
if (appEnvironment.environment === "local") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", {disableWarnings: true});
  connectFirestoreEmulator(db, "127.0.0.1", 8288);
  connectStorageEmulator(storage, "127.0.0.1", 9298);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export { app, auth, db, storage, legacyStorage, functions };
